import { JoinInner, JoinLeft, JoinRight } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { EmulatorType } from '@localstack/types';
import { ReactElement } from 'react';

const EMULATOR_ICON: Record<EmulatorType, { Icon: typeof JoinLeft; color: (theme: Theme) => string }> = {
  [EmulatorType.AWS]: { Icon: JoinLeft, color: (theme) => theme.palette.aws.primary },
  [EmulatorType.SNOWFLAKE]: { Icon: JoinInner, color: (theme) => theme.palette.snowflake.primary },
  [EmulatorType.AZURE]: { Icon: JoinRight, color: (theme) => theme.palette.azure.primary },
};

export type EmulatorIconProps = SvgIconProps & {
  emulator: EmulatorType;
};

export const EmulatorIcon = ({ emulator, sx, ...props }: EmulatorIconProps): ReactElement => {
  const { Icon, color } = EMULATOR_ICON[emulator];

  return <Icon sx={[{ color }, ...(Array.isArray(sx) ? sx : [sx])]} {...props} />;
};
